<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    //首先我们获得视口高度并将其乘以1%以获得1vh单位的值
    let vh = window.innerHeight * 0.01;
    // 然后，我们将——vh自定义属性中的值设置为文档的根
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    // 我们监听resize事件 视图大小发生变化就重新计算1vh的值
    window.addEventListener("resize", () => {
      // 我们执行与前面相同的脚本
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
};
</script>
<style lang="less">
@import "./assets/css/normalize.css";
@import "./assets/css/main.css";
@import "./assets/css/common.css";
@import "./assets/css/cz.css";
.text-ellipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
@media only screen and (max-width: 768px) {
  .mobile-view {
    width: 375px !important; /* 模拟 iPhone 6/7/8 宽度 */
    margin: 0; /* 去除默认边距 */
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
}
.h2_title {
  font-size: 32px;
  font-weight: 600;
  color: #333333;
  line-height: 45px;
}

.hezi_padding {
  padding: 24px 26px 35px 26px;
  box-sizing: border-box;
}

.wushuju {
  margin-top: 30px;
  font-size: 24px;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 33px;
}

.loading {
  z-index: 9999999999;
  position: relative;
}

page {
  font-family: Monospaced Number, Chinese Quote, -apple-system,
    BlinkMacSystemFont, Segoe UI, Roboto, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif !important;
}

::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
  color: transparent;
}

.nullimg {
  width: 448px;
  height: 348px;
}

/**app.wxss**/
.flex-direction-row {
  display: flex;
  align-items: center;
}

.flex-direction-column {
  display: flex;
  flex-direction: column;
}

.heading2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.agmbox {
  font-size: 15px;
  color: #a7a7a7;
  line-height: 17px;
  align-items: center;
  margin-top: 26px;
}

.agmbox p {
  font-size: 15px;
  font-weight: 400;
  color: #1db58a !important;
  line-height: 33px;
}

/*页面初始化*/
.customActive {
  font-size: 38px;
  border: none;
  color: black;
  background-color: transparent !important;
  border-bottom: 0 !important;
}

.isCustomActive {
  font-size: 38px;
  border: none;
  color: black;
  background-color: #ffffff !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

.navTitle {
  font-size: 34px !important;
  font-weight: 400;
  color: #333333;
}

.comStyBox {
  background-color: #f6f6f6;
  width: 100vw;
  min-height: 100vh;
}

.comStyTent {
  padding: 0 11px 0 22px;
  box-sizing: border-box;
}

.navBoxHid {
  width: 100%;
  height: 160px;
}

.van-nav-bar {
  z-index: 1 !important;
}

.van-nav-bar::after {
  border-bottom: none !important;
}

.nullstatebox {
  width: 100%;
  margin-top: 200px;
  align-items: center;
}

.nullstatebox p {
  color: #a3a3a3;
  text-align: center;
}

.text-ellipsis {
  white-space: nowrap;
  /* 文本不换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
}

.text-ellipsis-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  /* 控制最大显示行数 */
  white-space: normal;
  /* 允许文本换行 */
  overflow: hidden;
  /* 隐藏溢出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.centerbox {
  display: flex;
  width: 100%;
  justify-content: center;
}
input {
  border: none;
  outline: none;
  background-color: transparent;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
